import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map, of, switchMap, take } from 'rxjs';
import { AppRoutes, companyRoute } from '../../app.routes';
import { Company } from '../../models/company';
import { CompanyService } from '../../services/api/company/company.service';
import { UserService } from '../../services/api/user/user.service';
import { Action, PermissionService, Resource } from '../../services/permission/permission.service';

@Component({
    selector: 'app-redirect',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class RedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit(): void {
    this.redirectToRoute();
  }

  private redirectToRoute() {
    const redirectTo = this.activatedRoute.snapshot.data['redirectTo'] as AppRoutes;
    this.userService.currentUser$.pipe(
      filter(user => Boolean(user)),
      take(1),
      switchMap(() => this.companyService.currentCompany$.pipe(take(1))),
      switchMap(company => this.getRedirectRoute(company, redirectTo)),
    ).subscribe(route => {
      this.router.navigateByUrl(route, { replaceUrl: true });
    });
  }

  private getRedirectRoute(company: Company | null, redirectTo: AppRoutes) {
    const defaultRoute = companyRoute(redirectTo, company);
    if (!company || redirectTo !== AppRoutes.Dashboard) {
      return of(defaultRoute);
    }

    return this.permissionService.getPermissions(company, [Resource.Dashboard]).pipe(
      map(permissions => {
        return permissions.canAccess(Action.Get, Resource.Dashboard)
          ? defaultRoute
          : companyRoute(AppRoutes.Appointments, company);
      }),
    );
  }
}
